import React, { useEffect } from 'react';

import { VIDEO_COMPONENTS, type ITabItem } from './TabsBlock.interface';
import './TabsBlock.styles.css';

// Preload video components if any tab contains them to preload external scripts and styles
export const usePreloadVideoComponent = ({
  tabs,
  setShouldPreloadedId,
}: {
  tabs: ITabItem[];
  setShouldPreloadedId: React.Dispatch<React.SetStateAction<string | null>>;
}) => {
  useEffect(() => {
    const videoTabContent = tabs.find((tab) =>
      tab.items?.some((item) => VIDEO_COMPONENTS.includes(item.name)),
    );
    setShouldPreloadedId(videoTabContent ? videoTabContent.value : null);
  }, [tabs]);
};
